<script setup>
import {ref, inject, computed} from "vue";
import StartupModal from "@/views/needs/need/startupModal/StartupModal.vue";
import {getLogo} from "@/helpers/logo";
import UpgradeRequestModal from "@/views/needs/need/solutions/UpgradeRequestModal.vue";

const emit = defineEmits(['evaluate']);

const need = inject('need');
const startups = inject('solutions');
const escalated = inject('escalated');

const startupModal = ref(null);
const upgradeRequestModal = ref(null);

const unreviewedStartups = computed(() => startups.value.filter(s => !s.rating));

function showStartupDetails(linkId) {
    startupModal.value.open(linkId)
}

function review() {
    if (unreviewedStartups.value.length) {
        showStartupDetails(unreviewedStartups.value[0].link_id);
    }
}
</script>

<template>
    <div v-if="startups.length || !escalated" class="card-needs">
        <header class="card-needs__header">
            <h3 class="heading3 heading3--solutions">Evaluated Solutions</h3>
            <a
                v-if="unreviewedStartups.length"
                class="link"
                @click="review"
            >
                {{unreviewedStartups.length}} Unreviewed
            </a>
        </header>

        <div v-if="startups.length" class="card-needs__content card-needs__content--row">
            <div
                v-for="startup in startups"
                :key="startup.id"
                class="card-needs__content--col"
                @click="showStartupDetails(startup.link_id)"
            >
                <div class="card-headline">
                    <div class="card-headline__content">
                        <header class="card-headline__content__header">
                            <div class="image-block">
                                <img :src="getLogo(startup.logo)" alt="">
                            </div>
                            <div>
                                <h5 class="heading5 heading5--secondary">{{startup.name}}</h5>
                                <p v-if="startup.match_score" class="">Partnership Readiness: {{startup.match_score}}/10</p>
                            </div>
                        </header>

                        <p>{{startup.description}}</p>

                        <footer class="card-headline__content__footer">
                            <div class="rating-section rating-section--complex">
                                <div class="rating">
                                    <span
                                        v-for="index in [1,2,3,4,5]"
                                        :key="index"
                                        :class="{'rating__current': startup.rating >= index}"
                                    />
                                </div>
                            </div>

                            <div class="card-headline__author card-headline__author--ai"></div>
                        </footer>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="card-needs__content">
            <template v-if="need.recommended_startups_count">
                <p>Evaluate your AI matches to unlock more recommendations</p>

                <button class="btn btn-primary" @click="emit('evaluate')">Evaluate</button>
            </template>

            <template v-else>
                <p>Add AI and ecosystem-suggested solutions or upgrade your account to search over 650,000 startups</p>

                <button class="btn btn-primary" @click="upgradeRequestModal?.open()">Request Upgrade</button>
            </template>
        </div>

        <StartupModal ref="startupModal"/>

        <UpgradeRequestModal ref="upgradeRequestModal"/>
    </div>
</template>

<style scoped>

</style>
